import { FilterDocumentDurationTypes } from '@griply/types';

export const processDurationFilterToString = (
  duration: number,
  type: FilterDocumentDurationTypes = FilterDocumentDurationTypes.Minutes,
) => `${duration}:${type}`;

export const processDurationFilterFromString = (duration: string) => {
  const [value, type] = duration.split(':');

  return {
    value: parseFloat(value),
    type:
      type === FilterDocumentDurationTypes.Hours
        ? FilterDocumentDurationTypes.Hours
        : FilterDocumentDurationTypes.Minutes,
  };
};
